import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { KiGesendet } from '../../../models/ki.model';

@Component({
  selector: 'app-ki-gesendet',
  imports: [MatIconModule, TranslatePipe],
  templateUrl: './ki-gesendet.component.html',
  styleUrl: './ki-gesendet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiGesendetComponent {
  readonly gesendet = input.required<KiGesendet>();

  protected readonly offen = signal(false);
  protected readonly inhalte = computed(() => this.gesendet().inhalte.join(' · '));

  protected umschalten(): void {
    this.offen.update((offen) => !offen);
  }
}
